enum Page {
  Main = "Main",
  Home = "Home",
  Landing = "Landing",
  Sales = "Sales",
  Inventory = "Inventory",
  Campaign = "Campaign",
  Accounts = "Accounts",
  Users = "Users",
  Company = "Company",
  Reports = "Reports",
  SalesChanges = "SalesChanges",
  Apollo = "Apollo",
  Hubble = "Hubble",
  Kepler = "Kepler",
  Magellan = "Magellan",
  HubbleSignup = "HubbleSignup",
  HubbleProductDetails = "HubbleProductDetails",
  LogisticsProductDetails = "LogisticsProductDetails",
  ErrorSellers = "ErrorSellers",
  Trial = "Trial",
  Rosetta = "Rosetta",
  Logistics = "Logistics",
  Gemini = "Gemini",
  Settings = "Settings",
  Billing = "Billing",
  Pheonix = "Pheonix",
  Perseverance = "Perseverance",
  WhiteLabel = "WhiteLabel",
  Ulysses = "Ulysses",
  Ranger = "Ranger",
  Voyager = "Voyager",
  Sellers = "Sellers",
  Payment = "Payment",
  CreateAccount = "CreateAccount",
  ForgotPassword = "ForgotPassword",
  Products = "Products",
  Analytics = "Analytics",
}

export const ROUTES: Record<Page, string> = {
  Main: "/",
  Home: "/dashboard",
  Landing: "/home",
  Sales: "/sales",
  Inventory: "/inventory",
  Campaign: "/campaign",
  Accounts: "/accounts",
  Users: "/home/users",
  Company: "/company",
  Reports: "/reports",
  SalesChanges: "/home/sales_changes",
  Apollo: "/home/shipment_tracker",
  Hubble: "/ridgewood",
  Magellan: "/home/forecasting",
  Kepler: "/home/replenishment_planning",
  HubbleSignup: "/ridgewood/signup",
  HubbleProductDetails: "/ridgewood/productDetails",
  LogisticsProductDetails: "/ridgewood/logisticsPayment",
  Trial: "/trial",
  Rosetta: "/home/performance_dashboard",
  Logistics: "/ridgewood/logistics",
  Gemini: "/home/listing_health",
  Settings: "/settings",
  Billing: "/billing",
  Ulysses: "/home/promo_calendar",
  Perseverance: "/home/catalog_tracker",
  Pheonix: "/home/payment_reports",
  WhiteLabel: "/ridgewood/whitelabel",
  Ranger: "/home/fulfillment_fees",
  Voyager: "/home/sales_view_and_reports",
  Sellers: "/home/sellers",
  Payment: "/payment",
  ErrorSellers: "/home/error",
  CreateAccount: "/home/verify_account",
  ForgotPassword: "/home/forgot_password",
  Products: "/home/products",
  Analytics: "/home/analytics",
};
